import { useRef, useState } from "react";

// Trappola invisibile anti-bot (honeypot + tempo di compilazione).
// Gli umani non vedono né compilano il campo; i bot automatici sì.
// Uso: const hp = useHoneypot();  →  <hp.Field /> dentro il form  →  ...hp.payload() nel body
export function useHoneypot() {
  const [value, setValue] = useState("");
  const start = useRef(Date.now());

  const Field = () => (
    <input type="text" name="website" value={value} onChange={(e) => setValue(e.target.value)}
      tabIndex={-1} autoComplete="off" aria-hidden="true" data-testid="hp-field"
      className="absolute -left-[9999px] top-auto h-px w-px overflow-hidden opacity-0 pointer-events-none" />
  );

  const payload = () => ({ website: value, elapsed_ms: Date.now() - start.current });

  return { Field, payload };
}
